import Banner from "@/widgets/Banner/Templates/Banner";
import BannerLazy from "@/widgets/Banner/Templates/BannerLazy";
import { BannerCajaGris, BannerSticky } from "@/shared/ContentBanner";
import { ArticuloServiceLayoutContainer, ParentListBox, ListThreeColumns, Card } from "./styles";
import OnexOne from "@/widgets/Nota/Templates/OnexOne";
import Separator from "@/shared/Separator";
import { getImages } from "../helpers";
import { ContainerAuto } from "@/shared/ContainerAuto";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const ArticuloServiceLayout = (props) => {

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};

  const article = rest?.properties?.service?.data?.notes;
  const url = `/tema/${rest?.properties?.service?.slug}.html`;
  const template = rest?.properties?.service?.template;
  const mapping = formatContent?.sizeBanner;
  const adsPath = formatContent?.adsPath;

  if (!article) return <></>;

  return (
    <ContainerAuto>
      <ArticuloServiceLayoutContainer>
        <div className='banner-container'>
          <BannerCajaGris>
            <BannerLazy slotId={"horizontal2"} adsPath={adsPath} mapping={mapping.horizontal2} />
          </BannerCajaGris>
        </div>
        {template && template != "RadioLive" &&
          <Separator title="Artículos" tag="p" />
        }
        <ParentListBox>
          <div className="div1">
            <ListThreeColumns >
              {article?.map((element, id) => {
                const { name = "" } = element;
                let title = element.title || element.value.title
                let url = element.url || element.value.url
                let subtitle = element.subtitle ? element?.subtitle : element.value?.summary
                let metadata = element.metadata ? element?.metadata : element.value?.metadata
                let publishedDate = element.publishedDate ? element?.publishedDate : ""
                let authors = element.authors ? element?.authors : {}
                return (
                  <Card key={`Art ${id}`}>
                    <OnexOne
                      url={url}
                      title={title ? title : name}
                      subtitle={subtitle}
                      images={getImages(element)}
                      author={authors}
                      publishedDate={publishedDate}
                      metadata={metadata && metadata}
                      cutTitle={true}
                      showDate={true}
                    />
                  </Card>
                );
              })}
            </ListThreeColumns>
            {template && template != "RadioLive" &&
              <a href={url} className="astrology-today">
                VER MÁS
              </a>
            }
          </div>
          <div className="div2 banners">
            <BannerCajaGris>
              <Banner slotId={"caja2"} />
            </BannerCajaGris>
            <BannerCajaGris>
              <BannerLazy slotId={"caja3"} adsPath={adsPath} mapping={mapping.caja3} />
            </BannerCajaGris>
            <BannerCajaGris>
              {/* <BannerLazy slotId={"caja4"} adsPath={adsPath} mapping={mapping.caja4} /> */}
              <Banner isPreview={props.isPreview} slotId={"caja4"} />
            </BannerCajaGris>
          </div>
        </ParentListBox>
      </ArticuloServiceLayoutContainer>
    </ContainerAuto>

  );
};

export default ArticuloServiceLayout;